import React from 'react';
import NotificationsHeader from '../NotificationsHeader';
import NotificationsContent from '../NotificationsContent';
import '../Notifications.css';

const NotificationsServer = () => {
    return (
        <div className="notifications-page">
            <NotificationsHeader />
            <NotificationsContent />
        </div>
    );
};

export default NotificationsServer;
